
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Blog from '../pages/blog/page';
import Contact from '../pages/contact/page';
import Shop from '../pages/shop/page';
import Workshops from '../pages/workshops/page';
import Speaking from '../pages/speaking/page';
import NotFound from '../pages/NotFound';
import JournalPreview from '../pages/journal-preview/page';
import PowerOfRecordingDreams from '../pages/blog/power-of-recording-dreams/page';
import CreatingPersonalVisionMap from '../pages/blog/creating-personal-vision-map/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/shop',
    element: <Shop />,
  },
  {
    path: '/workshops',
    element: <Workshops />,
  },
  {
    path: '/speaking',
    element: <Speaking />,
  },
  {
    path: '/journal-preview',
    element: <JournalPreview />
  },
  {
    path: '/blog/power-of-recording-dreams',
    element: <PowerOfRecordingDreams />
  },
  {
    path: '/blog/creating-personal-vision-map',
    element: <CreatingPersonalVisionMap />
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
